/**
 * Et visningsnavn delt i fornavn og etternavn — RESERVEN, ikke kilden.
 *
 * Navnet er to felt i hele appen (QA15 2b), men kontoer og kontakter laget før det har bare
 * `displayName`. Da deles det ved SISTE mellomrom: «Anne Kari Dahl Hansen» blir «Anne Kari Dahl» +
 * «Hansen» — riktig oftere enn alternativet, og feltene står åpne for den som vet bedre.
 * Tre steder trengte den (invitasjonsdialogen, Bli med-siden og profilvinduet, QA5 A), så den bor her.
 */
export function splitDisplayName(whole: string | null | undefined): {
  givenName: string;
  familyName: string;
} {
  const parts = (whole ?? '')
    .trim()
    .split(/\s+/)
    .filter((part) => part !== '');
  /*
   * EN E-POSTADRESSE ER IKKE ET NAVN (QA13 #10). En person laget før navnet fulgte med, har
   * adressen som visningsnavn, og profilvinduet satte den i Fornavn. Tomme felt sier «skriv navnet
   * ditt»; adressen i Fornavn sa at den var navnet.
   */
  if (parts.length === 0 || (parts.length === 1 && parts[0]?.includes('@') === true)) {
    return { givenName: '', familyName: '' };
  }
  if (parts.length === 1) return { givenName: parts[0] ?? '', familyName: '' };
  return {
    givenName: parts.slice(0, -1).join(' '),
    familyName: parts[parts.length - 1] ?? '',
  };
}

/**
 * Et telefonnummer slik folk skriver dem: siffer, mellomrom, `+`, bindestrek, parentes og punktum,
 * og minst fem siffer. «abc» ble lagret og vist som telefon (QA5 A).
 */
export function looksLikePhone(value: string): boolean {
  const trimmed = value.trim();
  if (!/^\+?[\d\s().-]+$/.test(trimmed)) return false;
  return trimmed.replace(/\D/g, '').length >= 5;
}
